import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";
import type { AppRole } from "@shared/types/roles";

type ChipColor = "primary" | "secondary" | "error";

const ROLE_COLOR: Record<AppRole, ChipColor> = {
  "platform.admin": "error",
  "corpus.annotator": "primary",
  "expert_insights.expert": "secondary",
};

const ROLE_KEY: Record<AppRole, string> = {
  "platform.admin": "roles.platform_admin",
  "corpus.annotator": "roles.corpus_annotator",
  "expert_insights.expert": "roles.expert_insights_expert",
};

export interface RoleChipProps {
  role: AppRole;
}

/** Compact tag for an AppRole. Uses the app-wide flat Chip styling (see theme MuiChip). */
export function RoleChip({ role }: RoleChipProps) {
  const { t } = useTranslation();
  return (
    <Chip label={t(ROLE_KEY[role], { defaultValue: role })} color={ROLE_COLOR[role]} size="small" />
  );
}
